"use strict";

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("/app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthAPI = exports.BROWSER_NO_CREDENTIAL_API_MESSAGE = void 0;

var helpers_1 = require("../../helpers");

var types_1 = require("../../state/types");

var types_2 = require("./types");

var consts_1 = require("../../consts");

exports.BROWSER_NO_CREDENTIAL_API_MESSAGE = "Saleor SDK is unable to use browser Credential Management API.";

var AuthAPI = /*#__PURE__*/function (_helpers_1$ErrorListe) {
  _inherits(AuthAPI, _helpers_1$ErrorListe);

  var _super = _createSuper(AuthAPI);

  function AuthAPI(saleorState, jobsManager, config) {
    var _this;

    _classCallCheck(this, AuthAPI);

    _this = _super.call(this);
    /**
     * Tries to register a user account with given email and password.
     * @param email Email used for new account.
     * @param password Password used for new account.
     * @param redirectUrl URL used for redirection.
     */

    _this.registerAccount = function (email, password, redirectUrl) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$this$jobsManag, data, dataError;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.jobsManager.run("auth", "registerAccount", {
                  email: email,
                  password: password,
                  redirectUrl: redirectUrl
                });

              case 2:
                _yield$this$jobsManag = _context.sent;
                data = _yield$this$jobsManag.data;
                dataError = _yield$this$jobsManag.dataError;

                if (dataError === null || dataError === void 0 ? void 0 : dataError.error) {
                  this.fireError(dataError.error, types_2.DataErrorAuthTypes.REGISTER_ACCOUNT);
                }

                if (!dataError) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", {
                  data: data,
                  dataError: dataError,
                  pending: false
                });

              case 8:
                return _context.abrupt("return", {
                  data: data,
                  pending: false
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Requests a password reset for an user account with given email.
     * @param email Email used for account.
     * @param redirectUrl URL used for redirection.
     */


    _this.resetPasswordRequest = function (email, redirectUrl) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _yield$this$jobsManag2, data, dataError;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.jobsManager.run("auth", "resetPasswordRequest", {
                  email: email,
                  redirectUrl: redirectUrl
                });

              case 2:
                _yield$this$jobsManag2 = _context2.sent;
                data = _yield$this$jobsManag2.data;
                dataError = _yield$this$jobsManag2.dataError;

                if (dataError === null || dataError === void 0 ? void 0 : dataError.error) {
                  this.fireError(dataError.error, types_2.DataErrorAuthTypes.RESET_PASSWORD_REQUEST);
                }

                if (!dataError) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", {
                  data: data,
                  dataError: dataError,
                  pending: false
                });

              case 8:
                return _context2.abrupt("return", {
                  data: data,
                  pending: false
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    /**
     * Tries to authenticate user with given email and password.
     * @param email Email used for authentication.
     * @param password Password used for authentication.
     * @param autoSignIn Indicates if SDK should try to sign in user with given credentials in future without explicitly calling this method. True by default.
     */


    _this.signIn = function (email, password) {
      var autoSignIn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _yield$this$jobsManag3, data, dataError, _yield$this$jobsManag4, userData, userDataError;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.jobsManager.run("auth", "signIn", {
                  email: email,
                  password: password
                });

              case 2:
                _yield$this$jobsManag3 = _context3.sent;
                data = _yield$this$jobsManag3.data;
                dataError = _yield$this$jobsManag3.dataError;
                _context3.prev = 5;

                if (!(autoSignIn && !(dataError === null || dataError === void 0 ? void 0 : dataError.error) && consts_1.CREDENTIAL_API_EXISTS)) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 9;
                return navigator.credentials.store(new window.PasswordCredential({
                  id: email,
                  password: password
                }));

              case 9:
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](5);
                // eslint-disable-next-line no-console
                console.warn(exports.BROWSER_NO_CREDENTIAL_API_MESSAGE, _context3.t0);

              case 14:
                if (!dataError) {
                  _context3.next = 16;
                  break;
                }

                return _context3.abrupt("return", {
                  data: data,
                  dataError: dataError,
                  pending: false
                });

              case 16:
                _context3.next = 18;
                return this.jobsManager.run("auth", "provideUser", undefined);

              case 18:
                _yield$this$jobsManag4 = _context3.sent;
                userData = _yield$this$jobsManag4.data;
                userDataError = _yield$this$jobsManag4.dataError;

                if (!this.config.loadOnStart.checkout) {
                  _context3.next = 24;
                  break;
                }

                _context3.next = 24;
                return this.jobsManager.run("checkout", "provideCheckout", {
                  channel: this.config.channel,
                  isUserSignedIn: !!(data === null || data === void 0 ? void 0 : data.user)
                });

              case 24:
                return _context3.abrupt("return", {
                  data: userData,
                  dataError: userDataError,
                  pending: false
                });

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 11]]);
      }));
    };
    /**
     * Sign out user by clearing cache, local storage and authentication token.
     */


    _this.signOut = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _a;

        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.jobsManager.run("auth", "signOut", undefined);

              case 2:
                _context4.prev = 2;

                if (!((_a = navigator.credentials) === null || _a === void 0 ? void 0 : _a.preventSilentAccess)) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 6;
                return navigator.credentials.preventSilentAccess();

              case 6:
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](2);
                // eslint-disable-next-line no-console
                console.warn(exports.BROWSER_NO_CREDENTIAL_API_MESSAGE, _context4.t0);

              case 11:
                return _context4.abrupt("return", {
                  pending: false
                });

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 8]]);
      }));
    };
    /**
     * Tries to refresh user token to keep previously signed in user authenticated.
     * @param refreshToken Refresh token. Required when refreshToken is not provided as a cookie.
     */


    _this.refreshSignInToken = function (refreshToken) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _yield$this$jobsManag5, data, dataError;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.jobsManager.run("auth", "refreshSignInToken", {
                  refreshToken: refreshToken
                });

              case 2:
                _yield$this$jobsManag5 = _context5.sent;
                data = _yield$this$jobsManag5.data;
                dataError = _yield$this$jobsManag5.dataError;

                if (!dataError) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", {
                  data: data,
                  dataError: dataError
                });

              case 7:
                return _context5.abrupt("return", {
                  data: data
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    };

    _this.autoSignIn = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var credentials, _yield$this$signIn, dataError;

        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return navigator.credentials.get({
                  password: true
                });

              case 3:
                credentials = _context6.sent;
                _context6.next = 9;
                break;

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6["catch"](0);
                // eslint-disable-next-line no-console
                console.warn(exports.BROWSER_NO_CREDENTIAL_API_MESSAGE, _context6.t0);

              case 9:
                if (!(credentials && "password" in credentials && credentials.password)) {
                  _context6.next = 15;
                  break;
                }

                _context6.next = 12;
                return this.signIn(credentials.id, credentials.password, true);

              case 12:
                _yield$this$signIn = _context6.sent;
                dataError = _yield$this$signIn.dataError;

                if (dataError === null || dataError === void 0 ? void 0 : dataError.error) {
                  this.fireError(dataError.error, types_2.DataErrorAuthTypes.SIGN_IN);
                }

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 6]]);
      }));
    };

    _this.saleorState = saleorState;
    _this.jobsManager = jobsManager;
    _this.config = config;
    _this.loaded = false;
    _this.tokenRefreshing = false;
    _this.tokenVerifying = !!_this.saleorState.signInToken;

    _this.saleorState.subscribeToChange(types_1.StateItems.USER, function (user) {
      _this.user = user;

      if (_this.loaded) {
        _this.authenticated = !!_this.user;
      }
    });

    _this.saleorState.subscribeToChange(types_1.StateItems.SIGN_IN_TOKEN, function (token) {
      _this.token = token;
    });

    _this.saleorState.subscribeToChange(types_1.StateItems.SIGN_IN_TOKEN_REFRESHING, function (tokenRefreshing) {
      _this.tokenRefreshing = tokenRefreshing;
    });

    _this.saleorState.subscribeToChange(types_1.StateItems.SIGN_IN_TOKEN_VERIFYING, function (tokenVerifying) {
      _this.tokenVerifying = tokenVerifying;
    });

    _this.saleorState.subscribeToChange(types_1.StateItems.LOADED, function (loaded) {
      _this.loaded = loaded.user && loaded.signInToken;

      if (_this.loaded) {
        _this.authenticated = !!_this.user;
      }
    });

    if (!_this.saleorState.signInToken && consts_1.CREDENTIAL_API_EXISTS) {
      _this.autoSignIn();
    }

    return _this;
  }

  return _createClass(AuthAPI);
}(helpers_1.ErrorListener);

exports.AuthAPI = AuthAPI;